import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import siteConfig from "../config/siteConfig";

const footerGroups = [
  { title: "Company", links: [
    { label: "About Us", path: "/about" },
    { label: "Shop All", path: "/shop" },
    { label: "Best Sellers", path: "/shop?collection=best-sellers" },
  ] },
  { title: "Help", links: [
    { label: "FAQs", path: "/faqs" },
    { label: "Contact Us", path: "/contact" },
    { label: "Shipping", path: "/shipping" },
    { label: "Returns", path: "/returns" },
  ] },
  { title: "Legal", links: [
    { label: "All Policies", path: "/policies" },
    { label: "Privacy", path: "/privacy" },
    { label: "Cookie Policy", path: "/cookies" },
    { label: "Terms & Conditions", path: "/terms" },
    { label: "Payments & Billing", path: "/payments" },
    { label: "Accessibility", path: "/accessibility" },
  ] },
];

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="footer-support" aria-labelledby="footer-support-title">
        <div>
          <p className="footer-eyebrow">{siteConfig.tagline}</p>
          <h2 id="footer-support-title">Care that fits your everyday rhythm</h2>
        </div>
        <div className="footer-support__content">
          <p>
            Need help choosing a routine or checking an order? Our customer care
            team can help with product, delivery and return questions.
          </p>
          <div className="footer-contact" aria-label="Customer care and business location">
            <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
            <span>Country / region: {siteConfig.contact.country}</span>
            <span>Business address: {siteConfig.contact.addressStatus}</span>
            <span>{siteConfig.contact.hours}</span>
          </div>
        </div>
      </section>

      <div className="footer-main">
        <div className="footer-brand">
          <Link to="/" className="footer-wordmark" onClick={toTop}>
            {siteConfig.brandName}
          </Link>
          <p className="footer-brand__mission">{siteConfig.description}</p>
        </div>

        {footerGroups.map((group) => (
          <nav className="footer-column" aria-label={group.title} key={group.title}>
            <h3>{group.title}</h3>
            <ul>
              {group.links.map((item) => (
                <li key={item.label}><Link to={item.path} onClick={toTop}>{item.label}</Link></li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="footer-bottom">
        <p>{siteConfig.copyright}</p>
        <div className="footer-payments" aria-label="Supported payment methods">
          <span>Visa</span><span>Mastercard</span><span>American Express</span>
          <span>Apple Pay</span><span>Google Pay</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
